var exports = {
  "kL": "xa15a2ab7--4cb08b--container",
  "Ew": "xa15a2ab7--4cb08b--notification",
  "A4": "xa15a2ab7--4cb08b--control",
};

module.exports = exports;
